<template>
  <div class="ts-app-shell_fh">
    <div class="padd-main">
      <div style="margin-top: 20px;">
        <!-- <h5>
          <strong>{{pageTitle}}</strong>
        </h5>
        <div class="ts-app-shell--header_actions flexed">
          <button class="ts-btn ts-btn-small" @click="goBackToDashboard">Back to Dashboard</button>
        </div> -->
        <el-row :gutter="24">     
          <el-col :xl="16" :lg="16" :md="16" :sm="24" :xs="24">
            <h6>
              <strong class="mobile-menu">
                {{pageTitle}}
                <i class="fas fa-reply" @click="goBackToDashboard" style="font-size: 24px; margin-right: 20px; float: right"></i>
              </strong> 
            </h6>
          </el-col>
          <el-col :xl="8" :lg="8" :md="8" :sm="24" :xs="24">
            <div class="ts-app-shell--header_actions" style="float: right;">  
              <button class="ts-btn ts-btn-small" @click="goBackToDashboard">Back to Dashboard</button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="ts-app-landing-dashboard">
        <el-alert v-if="pageTitle == 'Job Offers'"
            v-bind:title="pageDescription + $t('lorganization')"
            type="warning"
            :closable="false"
          ></el-alert>
        <el-alert v-else
            v-bind:title="pageDescription + $t('lorganization') + 's'"
            type="warning"
            :closable="false"
          ></el-alert>
        <div v-if="activeName === 'first' && !showNoData">
          <el-table
            :height="tableHeight"
            :data="tableData.filter(data => !search || data.companyName.toLowerCase().includes(search.toLowerCase()))"
            style="width: 100%">
            <el-table-column label="Role Title" prop="roleTitle" width="250"></el-table-column>
            <el-table-column label="Company" prop="companyName" width="250"></el-table-column>
            <el-table-column label="Matching Percentage" prop="matchedPercentage" width="250">
              <template scope="scope">
                <div style="margin-left: 35px;">
                  <span v-if="Math.floor(scope.row.matchedPercentage) >= 0 && Math.floor(scope.row.matchedPercentage) <= 10" class="dot-quarter">{{Math.floor(scope.row.matchedPercentage)}}%</span>
                  <span v-if="Math.floor(scope.row.matchedPercentage) >= 11 && Math.floor(scope.row.matchedPercentage) <= 30" class="dot-half">{{Math.floor(scope.row.matchedPercentage)}}%</span>
                  <span v-if="Math.floor(scope.row.matchedPercentage) >= 31 && Math.floor(scope.row.matchedPercentage) <= 69" class="dot-third">{{Math.floor(scope.row.matchedPercentage)}}%</span>
                  <span v-if="Math.floor(scope.row.matchedPercentage) >= 70 && Math.floor(scope.row.matchedPercentage) <= 100" class="dot-whole">{{Math.floor(scope.row.matchedPercentage)}}%</span>
                </div>
              </template>            
            </el-table-column>
            <el-table-column align="right" width="250">
              <template slot="header" slot-scope="scope">
                <el-input v-model="search" size="mini" placeholder="Type to search" />
              </template>
              <template slot-scope="scope">
                <el-button class="btn-decline" @click="handleAccept(scope.$index, scope.row)">Accept</el-button>
                <el-button @click="handleDeline(scope.$index, scope.row)">Decline</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div v-if="activeName === 'second' && !showNoData">
          <el-table
            :height="tableHeight"
            :data="tableDataforAccepted.filter(data => !search || data.companyName.toLowerCase().includes(search.toLowerCase()))"
            style="width: 100%"
            empty-text
          >
            <el-table-column 
              width="200"
              label="Company" 
              prop="companyName">
            </el-table-column>
            <el-table-column 
              width="200"
              label="Role Title" 
              prop="roleTitle">
            </el-table-column>
            <el-table-column 
              width="200"
              label="Status" 
              prop="employerStatusName">
            </el-table-column>
            <el-table-column label="Matching Percentage" prop="matchedPercentage" width="200">
              <template scope="scope">
                <div style="margin-left: 35px;">
                  <span v-if="Math.floor(scope.row.matchedPercentage) >= 0 && Math.floor(scope.row.matchedPercentage) <= 10" class="dot-quarter">{{Math.floor(scope.row.matchedPercentage)}}%</span>
                  <span v-if="Math.floor(scope.row.matchedPercentage) >= 11 && Math.floor(scope.row.matchedPercentage) <= 30" class="dot-half">{{Math.floor(scope.row.matchedPercentage)}}%</span>
                  <span v-if="Math.floor(scope.row.matchedPercentage) >= 31 && Math.floor(scope.row.matchedPercentage) <= 69" class="dot-third">{{Math.floor(scope.row.matchedPercentage)}}%</span>
                  <span v-if="Math.floor(scope.row.matchedPercentage) >= 70 && Math.floor(scope.row.matchedPercentage) <= 100" class="dot-whole">{{Math.floor(scope.row.matchedPercentage)}}%</span>
                </div>
              </template>            
            </el-table-column>
            <el-table-column align="right" width="200">
              <template slot="header" slot-scope="scope">
                <el-input v-model="search" size="mini" placeholder="Type to search" />
              </template>
              <template slot-scope="scope">
                <el-button @click="handleView(scope.$index, scope.row)">View Details</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div v-if="activeName === 'third' && !showNoData">
          <el-table
            :height="tableHeight"
            :data="tableDataforAccepted.filter(data => !search || data.companyName.toLowerCase().includes(search.toLowerCase()))"
            style="width: 100%"
          >
            <el-table-column 
              width="300"
              label="Company" 
              prop="companyName">
            </el-table-column>
            <el-table-column 
              width="300"
              label="Role Title" 
              prop="roleTitle">
            </el-table-column>
            <el-table-column align="right" width="300">
              <template slot="header" slot-scope="scope">
                <el-input v-model="search" size="mini" placeholder="Type to search" />
              </template>
              <template slot-scope="scope">
                <!-- <el-button
                @click="handleView(scope.$index, scope.row)">Review Details</el-button>-->
                <el-button
                  class="btn-decline"
                  @click="handleOffer(scope.$index, scope.row)"
                >Accept Offer</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div v-if="showNoData" class="no-data">
      <div>
        <span class="fa-stack">
          <i class="fas fa-circle fa-stack-2x"></i>
          <i class="far fa-folder-open fa-stack-1x fa-inverse"></i>
        </span>
        <div class="no-data-text">{{ noDataText }}</div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  created() {
    this.activeName = this.$route.params.activeTab;

    if (this.activeName == 'first') {
      this.pageTitle = 'Invitations';
      this.noDataText = 'No active invitations yet';
      this.pageDescription = 'This lists all sent invitations by ';
      this.$store
        .dispatch(
          'jobseeker/getRequestBoard',
          1
        )
        .then(res => {
          this.tableData = res.requestBoardItems;
          this.showNoData = res.requestBoardItems.length == 0;
          this.calculateHeight();
        })
        .catch(res => {
          this.showNoData = true;
        });
    } else if (this.activeName == 'second') {
      this.pageTitle = 'Appointments';
      this.noDataText = 'No active appointments yet';
      this.pageDescription = 'This lists all confirmed appointments to ';
      this.$store
        .dispatch(
          'jobseeker/getRequestBoard',
          2
        )
        .then(res => {
          this.tableDataforAccepted = res.requestBoardItems;
          this.showNoData = res.requestBoardItems.length == 0;
          this.calculateHeight();
        })
        .catch(res => {
          this.showNoData = true;
        });
    } else {
      this.pageTitle = 'Job Offers';
      this.noDataText = 'No active offers yet';
      this.pageDescription = 'This lists all offers made by ';
      this.$store
        .dispatch(
          'jobseeker/getRequestBoard',
          4
        )
        .then(res => {
          this.tableDataforAccepted = res.requestBoardItems;
          this.showNoData = res.requestBoardItems.length == 0;
          this.calculateHeight();
        })
        .catch(res => {
          this.showNoData = true;
        });
    }
  },
  data() {
    return {
      tableData: [],
      tableDataforAccepted: [],
      search: '',
      activeName: '',
      pageTitle: '',
      showNoData: false,
      noDataText: '',
      pageDescription: '',
      tableHeight: 500
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.account.current_user;
    }
  },
  methods: {
    calculateHeight() {
      var view = document.body.offsetWidth;
      var responsive = (view > 759) ? 0 : 100;
      var x = document.getElementsByClassName('padd-main');
      //var y = document.getElementsByClassName('ts-app-landing-dashboard');
      this.tableHeight = x[0].clientHeight - 20 - responsive;
    },
    handleAccept(index, row) {
      this.$router.push({
        name: 'AcceptJobMatchDialog',
        params: { data: row }
      });
    },
    handleDeline(index, row) {
      row.isFrom = 'statusBoard';
      this.$router.push({
        name: 'DeclineJobMatchDialog',
        params: { data: row }
      });
    },
    handleClick(tab, event) {
      if (tab.name == 'first') {
        this.$store
          .dispatch(
            'jobseeker/getRequestBoard',
            this.$store.state.account.current_user.Id
          )
          .then(res => {
            this.tableData = res.requestBoardItems;
          });
      } else if (tab.name == 'second') {
        this.$store
          .dispatch(
            'jobseeker/getAcceptedBoard',
            this.$store.state.account.current_user.Id
          )
          .then(res => {
            this.tableDataforAccepted = res.requestBoardItems;
          });
      } else {
        this.$store
          .dispatch(
            'jobseeker/getJobOfferBoard',
            this.$store.state.account.current_user.Id
          )
          .then(res => {
            this.tableDataforAccepted = res.requestBoardItems;
          });
      }
    },
    handleView(index, row) {
      this.$router.push({ name: 'JobSeekerInfoDialog', params: { data: row } });
    },
    handleOffer(index, row) {
      this.$router.push({ name: 'AcceptOfferDialog', params: { data: row } });
    },
    goBackToDashboard() {
      this.$router.push({ name: 'JobSeekerDashboard' });
    },
  }
};
</script>

<style scoped>
.btn-decline {
  background-color: #14223c;
  color: white;
}

.mobile-menu .fa-reply{
    display: none !important;
  }

@media screen and (max-width: 759px) {
  .mobile-menu .fa-reply{
    display: inherit !important;
  }
}
</style>